<template>

  <v-container fluid class="pt-2 order-shipper-info" v-if="order">

    <!-- Title: Shipper -->
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="d-flex align-center">
        <!-- <v-icon color="white" class="mr-1">mdi-map-marker-outline</v-icon> -->
        <span class="title">{{ title }}</span>
      </v-col>
    </v-row>

    <!-- Location name -->
    <v-row class="pa-0 ma-0 mt-2 d-flex align-center">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Location:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div class="location-name" v-if="uiType === 'receiver'">{{ shipper.name }}</div>
        <router-link :to="generateShipperPageLink()" v-else>
          <span class="location-name">{{ shipper.name }}</span>
        </router-link>
      </v-col>
    </v-row>

    <!-- Address -->
    <v-row class="pa-0 ma-0 mt-2">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2" class="d-flex align-start">
        <div class="attr-label">Address:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div>{{ shipperMultilineAddress.street_1 }}</div>
        <div v-if="shipperMultilineAddress.street_2">{{ shipperMultilineAddress.street_2 }}</div>
        <div v-if="shipperMultilineAddress.area">{{ shipperMultilineAddress.area }}</div>
      </v-col>
    </v-row>

    <!-- Phone -->
    <v-row class="pa-0 ma-0 d-flex align-center">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Phone:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div>{{ shipper.phone }}</div>
      </v-col>
    </v-row>

    <!-- Primary email -->
    <v-row class="pa-0 ma-0 d-flex align-center" v-if="showEmail">
      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
        <div class="attr-label">Email:</div>
      </v-col>
      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
        <div v-if="shipperPrimaryEmail">{{ shipperPrimaryEmail.email }}</div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

export default {
  name: 'OrderShipperInfo',

  data () {
    return {
      showEmail: false,
      shipperEmails: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: 'Shipping From'
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    // -------------------- Shipper info
    shipper () {
      return this.order.shipper || {}
    },
    shipperMultilineAddress () {
      return this.$root.utils.getAddressTextFromData(this.shipper, { multi_lines: true })
    },
    shipperPrimaryEmail () {
      return (this.shipperEmails)
        ? this.shipperEmails.find(email => email.is_primary === true)
        : null
    }
  },

  async beforeMount () {
    this.loadRecipientEmails()
  },

  methods: {
    generateShipperPageLink () {
      return {
        name: 'shipper-item',
        params: { shipperId: this.shipper.id }
      }
    },

    // Load associated recipient emails
    async loadRecipientEmails () {
      // Load for shipper
      if (this.shipper.id) {
        try {
          const collection = await this.$store.dispatch('sh/dataApi', {
            method: 'get',
            uri: 'recipientEmails',
            opts: {
              params: { location_id: this.shipper.id }
            }
          })
          this.shipperEmails = collection.items
        } catch (err) {
          console.log('Error loading recipient emails for shipper =>', err)
        }
      } // end-if (this.shipper.id)
    }
  }
}
</script>

<style scoped>
  .order-shipper-info .location-name {
    font-size: 1.14rem;
  }

  .order-shipper-info a {
    text-decoration: none;
  }
  .order-shipper-info a:hover {
    text-decoration: underline;
  }
</style>
